const sidebarNav = [
    {
      link: "/",
      section: "Dashboard",
      icon: "material-symbols:dashboard-customize-outline-rounded",
      text: "Dashboard",
    },
    {
      link: "/onboarding",
      section: "onboarding",
      icon: "bxs:church",
      text: "onboarding",
    },
    {
      link: "/biometrics",
      section: "biometrics",
      icon: "ph:fingerprint",
      text: "Biometrics",
    },
    {
      link: "/messages",
      section: "messages",
      icon: "jam:messages-f",
      text: "Messages",
    },
];
  
  export default sidebarNav;
  